import FirestoreService from "shared/services/firebase/FirestoreService";

import { IState } from "..";
import GooglePlacesClient from "../../../services/Google/GooglePlacesClient";
import { Dispatch, getState } from "../../store/store";
import MembersChatSelectors from "../membersChat/MembersChatSelectors";
import CommonBotSelectors from "./CommonBotSelectors";
import RavenService from "../../../services/Logging/RavenService";
import FirestoreObserverFactory from "../../../services/firebase/database/observers/FirestoreObserverFactory";

let googlePlacesClient: GooglePlacesClient;

export const fetchLocationsAutoComplete = async (params: { query: string, generalSearch? : boolean }) => {
  try {
    const { query, generalSearch } = params;

    if (!googlePlacesClient) {
      googlePlacesClient = new GooglePlacesClient();
    }

    Dispatch.commonBot.setPlacesSearchQuery({ query });

    if (query.length === 0) {
      Dispatch.commonBot.setPlacesAutocomplete({ places: [] });
      return;
    } else {
      const places = await googlePlacesClient.fetchPlaces(query, generalSearch);

      const afterFetchQuery = CommonBotSelectors.placesSearchQuery(
        getState().commonBot
      );

      if (afterFetchQuery === query) {
        Dispatch.commonBot.setPlacesAutocomplete({ places });
      }
    }
  } catch (error) {
    console.error(error);
  }
};

export const connectWithLinkedin = async (_: {}, state: IState) => {
  const applicationId = MembersChatSelectors.applicationId(state.membersChat);
  if (!applicationId) {
    RavenService.captureMessage(
      `Observing linkedin connection with no application ID`
    );
    return;
  }

  await FirestoreService.createApplicationPublicEvents(applicationId!);
  observeLinkedinConnection(applicationId);
};

export const observeLinkedinConnection = (applicationId: string) => {
  try {
    const observer = FirestoreObserverFactory.publicEventsObserver(
      applicationId!
    );
    observer.subscribe(update => {
      if (update.connectedWithLinkedin) {
        observer.unsubscribe();
        Dispatch.commonBot.setConnectedWithLinkedin({
          connected: update.connectedWithLinkedin
        });
      }
    });
  } catch (error) {
    RavenService.captureException(error, {});
  }
};



// WEBPACK FOOTER //
// ./src/state/modules/commonBot/CommonBotEffects.ts